export const GAME_TITLE = 'Selamat Hari Jadi Mama!'

export const WIN_MESSAGES = ['Bagus!', 'Hebat', 'Syabas!']
export const GAME_COPIED_MESSAGE = 'Permainan disalin ke papan keratan'
export const ABOUT_GAME_MESSAGE = 'Tentang permainan ini'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'Tidak cukup huruf'
export const WORD_NOT_FOUND_MESSAGE = 'Perkataan tidak ditemui'
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `Perkataan itu adalah ${solution}`
export const ENTER_TEXT = 'Enter'
export const DELETE_TEXT = 'Delete'
export const STATISTICS_TITLE = 'Statistik'
export const GUESS_DISTRIBUTION_TEXT = 'Edaran Tekaan'
export const NEW_WORD_TEXT = 'Perkataan baru dalam masa'
export const SHARE_TEXT = 'Kongsi'
export const TOTAL_TRIES_TEXT = 'Jumlah percubaan'
export const SUCCESS_RATE_TEXT = 'Kadar kejayaan'
export const CURRENT_STREAK_TEXT = 'Streak semasa'
export const BEST_STREAK_TEXT = 'Streak tertinggi'
